<template>
  <div data-testid="main-nav__leading" class="main-nav__leading">
    <div
      data-testid="main-nav__logo"
      class="main-nav__logo"
      role="button"
      tabindex="0"
      aria-label="Go to home"
      @click="onLogoClick"
      @keydown.enter.prevent="onLogoClick"
      @keydown.space.prevent="onLogoClick"
    >
      <img
        v-if="!logoImageError"
        data-testid="main-nav__logo-img"
        class="main-nav__logo-img"
        src="/img/consark/ConsarcDark.svg"
        alt="Consarc.ai"
        @error="logoImageError = true"
      />
      <v-icon v-else data-testid="main-nav__logo-fallback" color="white">
        mdi-image-off-outline
      </v-icon>
    </div>

    <div data-testid="main-nav__app-switcher" class="main-nav__app-switcher">
      <app-switcher
        :applist="applist"
        @app-click="$emit('app-click', $event)"
      />
    </div>

    <div
      v-if="showInjectorDivider"
      data-testid="main-nav__leading-divider"
      class="main-nav__logo-divider"
      aria-hidden="true"
    />
  </div>
</template>

<script>
import AppSwitcher from './AppSwitcher.vue';
import { resolveLogoHomeRoute } from './mainNavUtils';

export default {
  name: 'MainNavLeading',
  components: { AppSwitcher },
  props: {
    showInjectorDivider: { type: Boolean, default: false },
    selectedClientId: { type: String, default: '' },
    applist: { type: Array, default: () => [] },
    clients: { type: Array, default: () => [] },
    logoHomeRoute: { type: String, default: null }
  },
  emits: ['logo-click', 'app-click'],
  data() {
    return {
      logoImageError: false
    };
  },
  computed: {
    resolvedLogoHome() {
      if (this.logoHomeRoute) return this.logoHomeRoute;
      const client = (this.clients || []).find((c) => c._id === this.selectedClientId) || null;
      return resolveLogoHomeRoute({
        routePath: this.$route.path,
        applist: this.applist,
        client,
        constants: this.$constants
      });
    }
  },
  methods: {
    onLogoClick() {
      const path = this.resolvedLogoHome;
      this.$emit('logo-click', path);
      if (path) {
        this.$nova.gotoLink({
          path,
          query: this.selectedClientId ? { cid: this.selectedClientId } : undefined
        });
      }
    }
  },
  beforeDestroy() {
    this.logoImageError = false;
  }
};
</script>

<style lang="scss" scoped>
@import './MainNavLeading.scss';
</style>

<style lang="scss">
@import './AppSwitcher.scss';
</style>
